import styled from 'styled-components'
import { vimovaTheme } from '../../theme/vimovaTheme'

/* ---------- Page layout ---------- */

export const ColumnsLayout = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;

  @media print {
    display: flex !important;
    gap: 16px !important;
    margin-top: 16px !important;
  }
`

export const ColumnCard = styled.div`
  flex: 1;
  background: transparent;
  border: 1px solid ${vimovaTheme.colors.border};
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;

  @media print {
    flex: 1 !important;
    background: transparent !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    border-radius: 12px !important;
    padding: 20px !important;
    display: flex !important;
    flex-direction: column !important;
  }
`

/* ---------- Section titles ---------- */

export const CardTitle = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 15px;
  color: ${vimovaTheme.colors.primary};
  margin-bottom: 6px;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 15px !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SubSectionTitle = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 15px;
  color: ${vimovaTheme.colors.primary};
  margin-top: 16px;
  margin-bottom: 6px;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 15px !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ---------- Score bar ---------- */

export const ScoreLabel = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 10px;
  color: ${vimovaTheme.colors.textLight};
  margin-bottom: 4px;

  @media print {
    font-size: 10px !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ScoreBarTrack = styled.div`
  height: 6px;
  border-radius: 3px;
  background: ${vimovaTheme.colors.backgroundMuted};
  margin-bottom: 12px;

  @media print {
    height: 6px !important;
    border-radius: 3px !important;
    background: ${vimovaTheme.colors.backgroundMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ScoreBarFill = styled.div<{ $width: number; $color?: string }>`
  height: 6px;
  border-radius: 3px;
  background: ${({ $color }) => $color || vimovaTheme.colors.green};
  width: ${({ $width }) => Math.min(100, $width)}%;

  @media print {
    height: 6px !important;
    border-radius: 3px !important;
    background: ${({ $color }) =>
      $color || vimovaTheme.colors.green} !important;
    width: ${({ $width }) => Math.min(100, $width)}% !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ---------- Quality class badge ---------- */

export const QualityBadge = styled.div`
  background: ${vimovaTheme.colors.primary}0F;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 8px;

  @media print {
    background: ${vimovaTheme.colors.primary}0F !important;
    border-radius: 8px !important;
    padding: 10px 14px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const QualityLabel = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 9px;
  color: ${vimovaTheme.colors.textLight};
  margin-bottom: 4px;

  @media print {
    font-size: 9px !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const QualityRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;

  @media print {
    display: flex !important;
    align-items: baseline !important;
    gap: 6px !important;
  }
`

export const QualityClass = styled.span`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: 900;
  font-size: 17px;
  color: ${vimovaTheme.colors.primary};

  @media print {
    font-weight: 900 !important;
    font-size: 17px !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const QualityDescription = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 10px;
  color: ${vimovaTheme.colors.textLight};

  @media print {
    font-size: 10px !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ---------- Metric boxes ---------- */

export const MetricsRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 10px;

  @media print {
    display: flex !important;
    gap: 8px !important;
    margin-bottom: 10px !important;
  }
`

export const MetricBox = styled.div`
  flex: 1;
  background: ${vimovaTheme.colors.primary}0D;
  border-radius: 6px;
  padding: 8px 10px;

  @media print {
    flex: 1 !important;
    background: ${vimovaTheme.colors.primary}0D !important;
    border-radius: 6px !important;
    padding: 8px 10px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricBoxLabel = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: ${vimovaTheme.colors.textLight};
  margin-bottom: 2px;

  @media print {
    font-size: 8px !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricBoxValue = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 15px;
  color: ${vimovaTheme.colors.primary};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 15px !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ---------- Sub-section header with icon ---------- */

export const SubSectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;

  @media print {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    margin-bottom: 8px !important;
  }
`

export const IconCircle = styled.div<{
  $bgColor: string
  $opacity?: number
}>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${({ $bgColor, $opacity }) =>
    $opacity
      ? `${$bgColor}${Math.round($opacity * 255)
          .toString(16)
          .padStart(2, '0')}`
      : $bgColor};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @media print {
    width: 20px !important;
    height: 20px !important;
    border-radius: 50% !important;
    background: ${({ $bgColor, $opacity }) =>
      $opacity
        ? `${$bgColor}${Math.round($opacity * 255)
            .toString(16)
            .padStart(2, '0')}`
        : $bgColor} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const IconLetter = styled.span<{ $color: string }>`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 9px;
  color: ${({ $color }) => $color};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 9px !important;
    color: ${({ $color }) => $color} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SubSectionLabel = styled.span`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 11px;
  color: ${vimovaTheme.colors.primary};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 11px !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ---------- Transport type badge ---------- */

export const TypeBadge = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 12px;
  border-radius: 4px;
  background: ${({ $color }) => $color};
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: 600;
  font-size: 8px;
  color: ${vimovaTheme.colors.white};
  margin-bottom: 6px;

  @media print {
    display: inline-flex !important;
    padding: 2px 12px !important;
    border-radius: 4px !important;
    background: ${({ $color }) => $color} !important;
    font-weight: 600 !important;
    font-size: 8px !important;
    color: ${vimovaTheme.colors.white} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ---------- Stop row ---------- */

export const StopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;

  @media print {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding: 4px 0 !important;
  }
`

export const StopName = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 10px;
  font-weight: 500;
  color: ${vimovaTheme.colors.primary};

  @media print {
    font-size: 10px !important;
    font-weight: 500 !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StopTime = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 10px;
  font-weight: 500;
  color: ${vimovaTheme.colors.primary};

  @media print {
    font-size: 10px !important;
    font-weight: 500 !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const TypeDivider = styled.div`
  height: 1px;
  background: ${vimovaTheme.colors.border};
  margin: 8px 0;
  opacity: 0.5;

  @media print {
    height: 1px !important;
    background: ${vimovaTheme.colors.border} !important;
    margin: 8px 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const Divider = styled.div`
  height: 1px;
  background: ${vimovaTheme.colors.border};
  margin: 12px 0;

  @media print {
    height: 1px !important;
    background: ${vimovaTheme.colors.border} !important;
    margin: 12px 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ---------- Road destination card ---------- */

export const DestinationCard = styled.div`
  background: ${vimovaTheme.colors.white};
  border: 0.5px solid ${vimovaTheme.colors.border};
  border-radius: 8px;
  padding: 10px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;

  @media print {
    background: ${vimovaTheme.colors.white} !important;
    border: 0.5px solid ${vimovaTheme.colors.border} !important;
    border-radius: 8px !important;
    padding: 10px 14px !important;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    margin-bottom: 8px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DestinationInfo = styled.div`
  flex: 1;
`

export const DestinationName = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-weight: 600;
  font-size: 10px;
  color: ${vimovaTheme.colors.primary};

  @media print {
    font-weight: 600 !important;
    font-size: 10px !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DestinationDistance = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 9px;
  color: ${vimovaTheme.colors.textLight};
  margin-top: 2px;

  @media print {
    font-size: 9px !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DriveTimeBadge = styled.div`
  background: ${vimovaTheme.colors.primary}0F;
  border-radius: 6px;
  padding: 6px 10px;
  text-align: center;
  flex-shrink: 0;
  margin-left: 10px;

  @media print {
    background: ${vimovaTheme.colors.primary}0F !important;
    border-radius: 6px !important;
    padding: 6px 10px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DriveTimeLabel = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: ${vimovaTheme.colors.textLight};

  @media print {
    font-size: 8px !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DriveTimeValue = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 12px;
  color: ${vimovaTheme.colors.primary};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 12px !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ---------- EV Station card ---------- */

export const EVStationCard = styled.div`
  background: ${vimovaTheme.colors.white};
  border: 0.5px solid ${vimovaTheme.colors.border};
  border-radius: 8px;
  padding: 10px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;

  @media print {
    background: ${vimovaTheme.colors.white} !important;
    border: 0.5px solid ${vimovaTheme.colors.border} !important;
    border-radius: 8px !important;
    padding: 10px 14px !important;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    margin-bottom: 8px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const EVStationInfo = styled.div`
  flex: 1;
`

export const EVStationName = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-weight: 600;
  font-size: 10px;
  color: ${vimovaTheme.colors.primary};

  @media print {
    font-weight: 600 !important;
    font-size: 10px !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const EVStationDetail = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: ${vimovaTheme.colors.textLight};
  margin-top: 2px;

  @media print {
    font-size: 8px !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const EVDistanceBadge = styled.div`
  background: ${vimovaTheme.colors.green}1F;
  border-radius: 6px;
  padding: 6px 10px;
  text-align: center;
  flex-shrink: 0;
  margin-left: 10px;

  @media print {
    background: ${vimovaTheme.colors.green}1F !important;
    border-radius: 6px !important;
    padding: 6px 10px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const EVDistanceValue = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 10px;
  color: ${vimovaTheme.colors.greenDark};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 10px !important;
    color: ${vimovaTheme.colors.greenDark} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const EVDistanceTime = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 7px;
  color: ${vimovaTheme.colors.textLight};
  margin-top: 1px;

  @media print {
    font-size: 7px !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ---------- Bottom score summary bar ---------- */

export const ScoreSummaryBar = styled.div`
  display: flex;
  align-items: center;
  background: ${vimovaTheme.colors.primary}0A;
  border-radius: 10px;
  padding: 10px 20px;
  margin-top: auto;
  gap: 0;

  @media print {
    display: flex !important;
    align-items: center !important;
    background: ${vimovaTheme.colors.primary}0A !important;
    border-radius: 10px !important;
    padding: 10px 20px !important;
    margin-top: auto !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ScoreSummaryItem = styled.div`
  flex: 1;

  @media print {
    flex: 1 !important;
  }
`

export const ScoreSummaryLabel = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 9px;
  font-weight: 500;
  color: ${vimovaTheme.colors.textLight};

  @media print {
    font-size: 9px !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ScoreSummaryValue = styled.div<{ $color?: string }>`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: 900;
  font-size: 15px;
  color: ${({ $color }) => $color || vimovaTheme.colors.primary};

  @media print {
    font-weight: 900 !important;
    font-size: 15px !important;
    color: ${({ $color }) => $color || vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ScoreSummaryDivider = styled.div`
  width: 1px;
  height: 28px;
  background: ${vimovaTheme.colors.border};
  margin: 0 16px;

  @media print {
    width: 1px !important;
    height: 28px !important;
    background: ${vimovaTheme.colors.border} !important;
    margin: 0 16px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
